import { gql } from "@apollo/client";

export const getLensQrCode = gql`
    query getLensQrCode($lensId: ID!) {
        getLens(input: { lensId: $lensId }) {
            lens {
                id
                qrCode {
                    deeplink
                    imagesList {
                        format
                        imageUrl
                    }
                }
            }
        }
    }
`;
